import Privacy from '@pages/privacy'

const PrivacyPage = () => <Privacy />

export const getStaticProps = () => ({
  props: {
    breadcrumbs: [{ label: 'Privacy Policy' }],
  },
})

export default PrivacyPage
